import { customBlogListReducer, CustomBlogListState } from "@iewccouk/Store/State/Blog/BlogListState";
import customSetInventoryResultsReducer from "@iewccouk/Store/State/Cart/CustomSetInventoryResultsModalReducer";
import CustomSetInventoryResultsModalState from "@iewccouk/Store/State/Cart/CustomSetInventoryResultsModalState";
import { customCategoriesReducer } from "@iewccouk/Store/State/Categories/CategoriesReducer";
import { CustomCategoriesState } from "@iewccouk/Store/State/Categories/CategoriesState";
import customCheckoutReviewAndSubmitReducer from "@iewccouk/Store/State/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitReducer";
import { CheckoutReviewAndSubmitState } from "@iewccouk/Store/State/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitState";
import { customCheckoutShippingReducer } from "@iewccouk/Store/State/CheckoutShipping/CheckoutShippingReducer";
import { CustomCheckoutShippingState } from "@iewccouk/Store/State/CheckoutShipping/CheckoutShippingState";
import customCreateAccountFormReducer from "@iewccouk/Store/State/CreateAccount/CreateAccountFormReducer";
import CreateAccountFormState from "@iewccouk/Store/State/CreateAccount/CreateAccountFormState";
import { customCountriesReducer, CustomCountriesState } from "@iewccouk/Store/State/Custom/CustomCountriesState";
import { customDownloadsReducer, CustomDownloadsState } from "@iewccouk/Store/State/Custom/CustomDownloadsState";
import { customLoadingPriceReducer, CustomLoadingPriceState } from "@iewccouk/Store/State/Custom/CustomLoadingPrice";
import { customModalsReducer, CustomModalsState } from "@iewccouk/Store/State/Custom/CustomModalsState";
import customAddedToCartModalReducer, {
    CustomAddedToCartModalState,
} from "@iewccouk/Store/State/Custom/CustomAddedToCartModalState";
import customSetSpoolModalReducer, { CustomSpoolModalState } from "@iewccouk/Store/State/Custom/CustomSpoolModalState";
import { customSystemListReducer, CustomSystemListState } from "@iewccouk/Store/State/Custom/CustomSystemListState";
import customDynamicFormReducer from "@iewccouk/Store/State/DynamicForm/DynamicFormReducer";
import DynamicFormState from "@iewccouk/Store/State/DynamicForm/DynamicFormState";
import customInstantRegistrationFormReducer from "@iewccouk/Store/State/InstantRegistration/InstantRegistrationFormReducer";
import InstantRegistrationFormState from "@iewccouk/Store/State/InstantRegistration/InstantRegistrationFormState";
import customNewShippingAddressFormReducer from "@iewccouk/Store/State/NewShippingAddress/NewShippingAddressFormReducer";
import NewShippingAddressFormState from "@iewccouk/Store/State/NewShippingAddress/NewShippingAddressFormState";
import customProductListReducer from "@iewccouk/Store/State/ProductList/ProductListReducer";
import { CustomProductListState } from "@iewccouk/Store/State/ProductList/ProductListState";
import customRequestQuoteFormReducer from "@iewccouk/Store/State/RfqRequestQuote/RequestQuoteFormReducer";
import RequestQuoteFormState from "@iewccouk/Store/State/RfqRequestQuote/RequestQuoteFormState";
import {
    customPurchasesByProductReducer,
    CustomPurchasesByProductState,
} from "@iewccouk/Store/State/SpendReporting/PurchasesByProductState";
import {
    customSpendReportingReducer,
    CustomSpendReportingState,
} from "@iewccouk/Store/State/SpendReporting/SpendReportingState";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

export type CustomState = {
    name: string;
    customCategories: CustomCategoriesState;
    blogList: CustomBlogListState;
    checkoutShipping: CustomCheckoutShippingState;
    customRequestQuoteForm: RequestQuoteFormState;
    customCreateAccountForm: CreateAccountFormState;
    customModals: CustomModalsState;
    customSystemList: CustomSystemListState;
    customCountriesList: CustomCountriesState;
    customReviewAndSubmit: CheckoutReviewAndSubmitState;
    customDownloads: CustomDownloadsState;
    customInventoryResultsModal: CustomSetInventoryResultsModalState;
    customNewShippingAddressForm: NewShippingAddressFormState;
    spendReportingState: CustomSpendReportingState;
    customProductList: CustomProductListState;
    customSpoolModal: CustomSpoolModalState;
    customAddedToCartModal: CustomAddedToCartModalState;
    customPurchasesByProductState: CustomPurchasesByProductState;
    customIsLoadingPrice: CustomLoadingPriceState;
    customInstantRegistrationForm: InstantRegistrationFormState;
    customDynamicForm: DynamicFormState;
} & ApplicationState;

(reducers as any).customCategories = customCategoriesReducer;
(reducers as any).blogList = customBlogListReducer;
(reducers as any).checkoutShipping = customCheckoutShippingReducer;
(reducers as any).customRequestQuoteForm = customRequestQuoteFormReducer;
(reducers as any).customCreateAccountForm = customCreateAccountFormReducer;
(reducers as any).customModals = customModalsReducer;
(reducers as any).customSystemList = customSystemListReducer;
(reducers as any).customCountriesList = customCountriesReducer;
(reducers as any).customReviewAndSubmit = customCheckoutReviewAndSubmitReducer;
(reducers as any).customDownloads = customDownloadsReducer;
(reducers as any).customInventoryResultsModal = customSetInventoryResultsReducer;
(reducers as any).customNewShippingAddressForm = customNewShippingAddressFormReducer;
(reducers as any).spendReportingState = customSpendReportingReducer;
(reducers as any).customProductList = customProductListReducer;
(reducers as any).customSpoolModal = customSetSpoolModalReducer;
(reducers as any).customAddedToCartModal = customAddedToCartModalReducer;
(reducers as any).customPurchasesByProductState = customPurchasesByProductReducer;
(reducers as any).customIsLoadingPrice = customLoadingPriceReducer;
(reducers as any).customInstantRegistrationForm = customInstantRegistrationFormReducer;
(reducers as any).customDynamicForm = customDynamicFormReducer;

type Reducers = {
    customCategories: typeof customCategoriesReducer;
    customBlogListReducer: typeof customBlogListReducer;
    customCheckoutShippingReducer: typeof customCheckoutShippingReducer;
    customRequestQuoteForm: typeof customRequestQuoteFormReducer;
    customCreateAccountForm: typeof customRequestQuoteFormReducer;
    customModals: typeof customModalsReducer;
    customSystemList: typeof customSystemListReducer;
    customReviewAndSubmit: typeof customCheckoutReviewAndSubmitReducer;
    customDownloads: typeof customDownloadsReducer;
    customInventoryResultsModal: typeof customSetInventoryResultsReducer;
    customNewShippingAddressForm: typeof customNewShippingAddressFormReducer;
    spendReportingState: typeof customSpendReportingReducer;
    customProductList: typeof customProductListReducer;
    customSpoolModal: typeof customSetSpoolModalReducer;
    customAddedToCartModal: typeof customAddedToCartModalReducer;
    customIsLoadingPrice: typeof customLoadingPriceReducer;
    customPurchasesByProductReducer: typeof customPurchasesByProductReducer;
    customInstantRegistrationForm: typeof customInstantRegistrationFormReducer;
    customDynamicForm: typeof customDynamicFormReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
